var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0163 10.275L13.9996 9.2583C13.7579 9.04997 13.6163 8.74163 13.6079 8.39997C13.5913 8.02497 13.7413 7.64997 14.0163 7.37497L15.0163 6.37497C15.8829 5.5083 16.2079 4.67497 15.9329 4.01663C15.6663 3.36663 14.8413 3.0083 13.6246 3.0083H4.29128C4.11628 3.01663 3.97461 3.1583 3.97461 3.3333V13.3333C3.97461 13.5083 4.11628 13.65 4.29128 13.65H13.6246C14.8246 13.65 15.6329 13.2833 15.9079 12.625C16.1829 11.9583 15.8663 11.1333 15.0163 10.275Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29166 18.3332C3.95 18.3332 3.66666 18.0498 3.66666 17.7082V2.2915C3.66666 1.94984 3.95 1.6665 4.29166 1.6665C4.63333 1.6665 4.91666 1.94984 4.91666 2.2915V17.7082C4.91666 18.0498 4.63333 18.3332 4.29166 18.3332Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.6889ee44cd249c33fa02e92303fa5e63.svg";
export { ForwardRef as ReactComponent };